export class FeeSelectionClass {
    async getExistingFees() {
        throw new Error("get existing fees in FeeSelection class needs to be overwritten");
    }
}